<div class="searchInput" [class]="color">
    <div class="title">
        Search  Lionsgate’s Library
    </div>
    <div class="searchInputField">
        <div class="searchBox">
            <input [(ngModel)]="searchService.searchText"  (ngModelChange)="onSearch($event)" (keyup.enter)="onSearchButton()">

            <div class="searchButton" (click)="onSearchButton($event)">
                <div class="label">Search</div>
            </div>
        </div>
    </div>

    <div class="filters" *ngIf="color == 'white'">
        <div class="settingIcon">
            <!-- <img *ngIf="color=='blue'" src="assets/setting-icon.png" alt=""> -->
            <img *ngIf="color=='white'" src="assets/setting-icon-white.png" alt="">
        </div>

        <app-round-select (click)="toggleFormatFilter()" label="Format" [color]="color" [active]="searchService.isFormatFilterOpen"></app-round-select>
        <app-round-select label="Genre" [color]="color" [active]="searchService.isGenreFilterOpen" (click)="toggleGenreFilter()"></app-round-select>
        <app-round-select (click)="toggleRatingFilter()" label="Rating" [color]="color" [active]="searchService.isRatingFilterOpen"></app-round-select>
    </div>
</div>
